/*
    Lets colate the sources/types here. If they change them, we don't have to hunt them down.
 */
export const LEAD_GEN_SOURCE_TYPES = {
  fieldSales: {
    type: 'Field Sales',
    name: 'Field Sales',
  },
  firstServiceDiscount: {
    type: 'Modal',
    name: 'Web Modal',
  },
  footer: {
    type: 'Footer',
    name: 'Web Footer',
  },
  skuGate: {
    type: 'Sku Gate',
    name: 'Web Sku Gate',
  },
  skuGateModal: {
    type: 'Sku Gate Modal',
    name: 'Web Sku Gate Modal',
  },
  lowTechCoverage: {
    type: 'Low Tech Coverage',
    name: 'Web Low Tech Coverage',
  },
  registration: {
    type: 'Account Registration',
    name: 'Web Registration Page',
  },
  registrationCheckout: {
    type: 'Account Registration',
    name: 'Web Checkout Page',
  },
  homehub: {
    type: 'Home Hub',
    name: '',
  },
};
